import { Translations } from '@/types/types';
import { ApiQueryKey } from '@/configs/apiQueryKey';
import EntityApi, { BaseEntity } from './EntityApi';

export enum AttributeViewType {
	TILES = 'TILES',
	CHIP = 'CHIP',
}

export enum AttributeType {
	MODULE = 'MODULE',
	GLOBAL = 'GLOBAL',
}

export interface Attribute extends BaseEntity {
	name: string;
	description: string;
	viewType: AttributeViewType;
	codePosition: number;
	listOrder: number;
	type: AttributeType;
	translations: Translations<{
		name: string;
		description: string;
	}>;
}

class AttributeApi extends EntityApi<Attribute> {
	constructor() {
		super(ApiQueryKey.attributes);
	}
}

export default new AttributeApi();
